import { POST, GET } from 'utils/requests.utils'

const BASE_URL = '/app/invite'

export const join = (id, data) => POST(`${BASE_URL}/${id}/join`, data)

export const checkPid = (id) => GET(`${BASE_URL}/check_pid/${id}`)
